export const DateTimeFormat = 'u-MM-dd kk:mm';
export const DateTimeHourBucketFormat = 'u-MM-dd kk:00';